import { Component, createEffect, createMemo, createSignal, onMount } from 'solid-js'
import { getEncoder } from '../../../../common/tokenize'
import Modal from '../../../shared/Modal'
import TextInput from '../../../shared/TextInput'
import { chatStore, i18nStore, userStore } from '../../../store'
import { AppSchema, TokenCounter } from '/common/types'
import { useParticipantList } from '../util'
import CharacterSelect from '/web/shared/CharacterSelect'

const PromptModal: Component = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const user = userStore((s) => ({ user: s.user }))
  const state = chatStore((s) => ({ prompt: s.prompt, chat: s.details[s.lastChatId]?.chat }))
  const [encoder, setEncoder] = createSignal<TokenCounter>()
  const [tokens, setTokens] = createSignal(0)
  const lists = useParticipantList(true)

  const options = createMemo(() => {
    const all = lists()

    return all.chars.concat(all.tempsActive).concat(all.tempsInactive)
  })

  onMount(async () => {
    const enc = await getEncoder()
    setEncoder(() => enc)
  })

  createEffect(async () => {
    if (!state.chat) return '...'
    if (!user.user) return '....'
    if (!encoder()) return '.....'

    const count = await encoder()!(state.prompt?.template.parsed || '')
    setTokens(count)
  })

  const setPerspective = (char?: AppSchema.Character) => {
    if (!char) return
    chatStore.computePrompt(state.prompt?.msg!, char)
  }

  return (
    <Modal
      show={!!state.prompt?.shown}
      close={chatStore.closePrompt}
      title={i18n.t.chat_msg_prompt_title}
      maxWidth="half"
    >
      <TextInput
        class="min-h-[300px] text-sm"
        fieldName="prompt"
        label={i18n.t.chat_option_prompt}
        helperText={
          <div class="flex flex-col gap-2">
            <div>
              {i18n.t.chat_prompt_approx_helper}
            </div>
            <div>
              {i18n.t.chat_prompt_budget_helper}
            </div>
            <div class="font-bold">{i18n.t.chat_est_tokens.replace('{count}', tokens().toString())}</div>
            <div class="mb-1">
              <CharacterSelect
                horz="right"
                items={options()}
                fieldName="prompt-perspective"
                onChange={setPerspective}
              />
            </div>
          </div>
        }
        value={state.prompt?.template.parsed}
        isMultiline
        disabled
      />
    </Modal>
  )
}

export default PromptModal
